module.exports = {
  "CS_info2_Network_Image_HvHe": "Image on Website",
  "CS_one_Batch_configuration_Ffmp": "Batch Configuration",
  "CS_5_When_the_PbND": "This inbound user is a rider, only rider’s tools are applicable.",
  "CS_one_Scenario_ENG_mFbn": "Scenario (en-US)",
  "CS_info_Comments_failed_mQNX": "Unable to add comment",
  "CS_5_Do_not_kYRj": "You’re doing that too much",
  "CS_2_It_is_vdcu": "Please first reply via in-app message (an email notification will also be sent). If you don’t know how, please ask your supervisor.",
  "CS_1_Template_oNtV": "Template",
  "CS_tickets_User_Type_Wdya": "User Type",
  "CS_info2_Please_fill_uLvw": "Please enter...",
  "CS_one_Operation_Log_hsdo": "Action Log",
  "CS_one_Tips_vbZx": "Attention",
  "CS_one_Upload_successfully_DliZ": "File uploaded successfully. It will take effect in the applicable country after being created. Please inform the relevant colleagues in the corresponding country.",
  "CS_info2_Cancel_link_vxaa": "Remove Link",
  "CS_1_Action_pnrH": "Actions",
  "CS_pop_The_conversation_dKAF": "Call Start Time",
  "CS_one_Upload_files_TzsC": "Upload File",
  "CS_1_Operational_results_nOpZ": "Action Result",
  "CS_one_Please_check_SuZo": "2. Upload the completed template (make sure everything is entered correctly before uploading).",
  "CS_1_Temporary_CTPp": "Save Temporarily",
  "CS_1_Solved_ooGh": "Resolved",
  "CS_page_Unable_to_aXip": "Unable to create ticket",
  "CS_one_Enter_rfGy": "Please enter",
  "CS_1_Message_Title_AJzH": "Email Subject",
  "CS_2_Worksheet_ID_SxiT": "Ticket ID is generated upon the ticket creation",
  "CS_2_Copy_the_hSGF": "Mobile number copied. This action has been logged. Please remember to follow the company’s information security policies.",
  "CS_one_Classification_of_qEgR": "Contact Reason Management",
  "ark.global.cs.field.values.ticket_tab_im": "Live Chat",
  "CS_qa_This_behavior_dZrQ": "Operations on this page are logged. Please follow the company’s information security policies.",
  "CS_Page_Driver_List_Uxwj": "Driver List",
  "CS_1_Thank_you_WUlL": "Thanks for your feedback!",
  "CS_info_Select_Question_QkZC": "Please select a Contact Reason",
  "CS_5_Your_query_uvJB": "Max query limit reached",
  "CS_one_Determination_GUbi": "Confirm",
  "CS_buchong_eFit_JNbR": "Unable to find order info because mobile number is invalid, or user is not registered.",
  "CS_Page_Rider_Details_Ovwp": "Rider Details: Rider ID",
  "CS_1_Amount_mYAW": "Amount",
  "CS_Page_Order_Details_oAUq": "Trip Details: Trip ID",
  "CS_Adjustment_YdjN_bXSL": "Reason for skipping SOP is inadequate. Please try a different one.",
  "CS_Adjustment_gjOY_YpxQ": "SOP information is inconsistent with PC information",
  "Fleet_0303_Fleet_WorkRegime_Contents_TAuX": "No content",
  "CS_buchong__yLly": "Unable to use tools because the mobile number is invalid, or the user is not registered",
  "CS_Tools_1209_Optimus_Coupon_Inuquiry_Scope_of_bBLW": "Rider ID ",
  "CS_one_Batch_effective_prPl": "Batch Validate",
  "CS_one_Country_and_Qyqv": "Country and Business Line Configuration",
  "CS_page_Please_fill_ikWU": "Please select a ticket group",
  "CS_tickets_Three_days_pcmE": "Past 3 days",
  "CS_one_New_Batch_wEKW": "Batch Create",
  "CS_one_Abandoned_ROgG": "Discarded",
  "CS_1_Enter_content_haAO": "Enter text here",
  "CS_one_Description_ENG_vIZz": "Description (en-US)",
  "CS_page_Work_orders_MRDt": "Ticket closed successfully",
  "CS_one_Translation_configuration_lnQZ": "Translation Configuration",
  "CS_tickets_Compensation_deduction_GJfV": "Compensation/Deduction Method",
  "CS_info_Like_failure_mPup": "An error occurred. Please try again.",
  "CS_info2_Make_sure_zyfT": "Before selecting this option, please ensure that city info is unavailable for this ticket",
  "verify---id_no_co": "Verify",
  "Help_version_Business_lines_VOJX": "Category",
  "CS_4_Topographic_tools_KqUl": "Map",
  "CS_Page_Driver_Type_UnIR": "Driver Type",
  "CS_information_Order_Basis_WKGU": "Basic Trip Info",
  "Magellan_improvement_The_company_CoIp": "Information such as IM and call history is confidential data that belongs to the company. Please use it in a reasonable manner according to our information security regulations. Each query will be logged by system. It is strictly forbidden to take photos, download, or disclose such data to any third party outside the company.",
  "CS_Page_Passenger_Details_vgGv": "Rider Details Page",
  "CS_Service_The_driver's_JbyZ": "Driver’s level was {{driver_level}} when this ticket was created",
  "CS_pop_No_xtIB": "No",
  "CS_pop_Cancel_byla": "Cancel",
  "Magellan_improvement_IM_Information_weuP": "IM information",
  "CS_info2_Reset_Fiiu": "Reset",
  "CS_1_E_mail_rKAg": "Email",
  "CS_tickets_Administrator_BcHW": "Manager",
  "CS_one_Action_Type_uHTo": "Action Type",
  "Magellan_improvement_Question_description_GyVD": "Issue description",
  "CS_page_Do_you_UfOG": "Transfer ticket to {{ticketgroup}}?",
  "CS_page_Transportation_orders_UWhR": "Transfer Ticket",
  "CS_tickets_One_month_IrdR": "Past 1 month",
  "CS_5_Unchecked_user_vuUZ": "User Registration Info not found",
  "CS_Settings_Countless_lEdc": "No data",
  "CS_page_Transferring_the_ZnkX": "Ticket transferred successfully",
  "Magellan_improvement_Call_completed_hbKz": "Call completed",
  "CS_improvement_Passenger_JnXD": "Rider",
  "CS_Page_Driver_Basic_SItd": "Basic Driver Info",
  "CS_one_Description_NrBC": "Description",
  "CS_Adjustment_abEf_PYol": "SOP contains a bug",
  "CS_4_Tools_can_ZQSK": "All tools can only be used on the Ticket Handling Page of the CS system",
  "CS_one_Owner_EwUa": "Owner",
  "CS_Page_Model_List_WVIO": "Vehicle Class List",
  "CS_Page_Common_tools_FTJG": "Common Tools",
  "CS_info_Click_here_MKRf": "Click here to associate 1 order",
  "CS_thpoptimization__sSiH": "Fleet",
  "CS_3_Optional_kdMP": "optional",
  "CS_pop_User_Phone_hTGd": "User Phone Number",
  "CS_Page_City_name_atjF": "City Name",
  "CS_Service_Driver_Level_qpqY": "Driver Level",
  "CS_improvement_Call_SmCo": "Call Time",
  "Help_version_Enter_number_MyWJ": "Incoming Phone No.",
  "CS_1_Comments_RcMN": "Submit",
  "CS_info_This_page_Cpww": "To avoid system lag, only up to 10 ticket tabs can be opened on this page. Please close unneeded tabs. Thank you!",
  "CS_tickets_Work_order_NQJE": "Ticket Status",
  "CS_one_Entered_into_mEwl": "In Effect",
  "CS_Adjustment_txhj_lfbO": "Please complete SOP before proceeding",
  "CS_tickets_Three_months_Jdzc": "Past 3 months",
  "CS_1_Order_ID_bsCY": "Order ID",
  "CS_tool_Work_order_LjeC": "Ticket Status",
  "CS_Page_Trip_Compl_Vcnk": "Trip End Time",
  "CS_page_No_permissions_mYZG": "You do not have permission to transfer this ticket",
  "CS_1_Send_email_DDPi": "Confirm Email Sending",
  "CS_buchong__BYdr": "Unable to locate user info or use the dynamic permissions verification feature because the mobile number is invalid, or the user is not registered.",
  "CS_one_New_Problem_ORNp": "Create New Contact Reason",
  "CS_Page_Select_the_kqHS": "Please select filtering conditions",
  "Help_version_Country_XKEj": "Country",
  "CS_translation_Selection_of_yatg": "Select Compensation Reason",
  "CS_2_Please_select_Zapc": "Please select",
  "CS_2_Refund_amount_ikWV": "Refund Amount",
  "CS_Page_Enter_Order_TeQM": "Enter trip ID",
  "CS_Page_Type_SnKr": "Model",
  "CS_QA1_More_than_uScx": "If there are more than {{amount}} entries, only {{amount}} will be shown.",
  "CS_one_Operation_Records_bTgJ": "Action Log",
  "CS_1_ID_VNVI": "Ticket ID",
  "CS_pop_Bind_session_qEwk": "Add A Call",
  "CS_info2_Jump_link_pUcH": "Redirect link",
  "CS_tickets_The_user_iVJx": "This user is a fleet manager (click to view details)",
  "ark.global.cs.field.values.ticket_tab_compensation": "Processing Record",
  "CS_info2_Depositary_UmEY": "Assignee",
  "CS_initialization_Create_a_xRhB": "Please create a ticket first",
  "CS_pop_Bind_lDQM": "Add",
  "CS_Page_Order_List_IiWy": "Trip List",
  "CS_one_Status_QWZW": "Status",
  "CS_page_Site_Name_dYcm": "Stop Name",
  "CS_information_Single_phone_vKdi": "Requester’s Phone No.",
  "CS_page__unk_uZmz": "Minibus Info",
  "CS_2_Driver_balance_otCh": "Deduction from driver’s balance",
  "CS_Notice_Please_submit_iVZB": "Please provide your feedback for this Process Card before submitting",
  "CS_info2_Link_kBeS": "Association",
  "CS_1_You_do_Czvx": "You do not have permission to view customers’ private information. Please perform system verification or contact the administrator.",
  "CS_info_Process_cards_ccmd": "Process Card",
  "CS_improvement_The_main_DIgv": "Caller hung up",
  "Help_2_More_OZUg": "More",
  "CS_1_Recipients_jNBa": "To",
  "CS_buchong1__XPiG": "Unable to perform this action because dynamic authentication failed. Please complete dynamic authentication, or contact the administrator.",
  "CS_Page_Enter_email_VDKC": "Enter email address",
  "CS_one_Return_axWQ": "Back",
  "CS_tickets_Complaint_Manner_UWAQ": "Respondent Related Ticket",
  "CS_2_Refundable_mKnQ": "Refund Available?",
  "CS_pop_Whether_to_tvgd": "Create a ticket without an associated call?",
  "CS_1_Send_an_oyHo": "Are you sure you want to send an email to this user?",
  "CS_one_Upload_failed_tubs": "Unable to upload. Please try again.",
  "CS_tickets_Order_Work_UDue": "Order Related Ticket",
  "Magellan_improvement_ID_HTMT": "Ticket ID",
  "CS_Page_Type_of_Chyl": "Query Type",
  "CS_initialization_Select_user_QGGG": "Please select a user type",
  "Help_version_Answer_DVQw": "Answer",
  "CS_improvement_Dial_man_vuMm": "Caller",
  "CS_one_Are_you_QXby": "Are you sure you want to modify this contact reason? Once modified, the CR will take effect in the applicable country. Please inform the relevant colleagues in the corresponding country.",
  "CS_info2_Data_Not_mVCx": "No data available",
  "CS_information_Purpose_tIXL": "Destination",
  "CS_Page_Response_mode_tfSQ": "Response Mode",
  "CS_Page_Order_Status_ZJEQ": "Order Status",
  "CS_1_Internal_message_Dmzz": "Internal Message",
  "CS_1_More_online_ugOQ": "More Chat History",
  "CS_page_Cancelled_xyYr": "Cancelled",
  "CS_one_1_Please_EOBr": "1. Download and fill out the following template.",
  "CS_one_Applicable_States_HNdh": "Applicable Country",
  "CS_translation_Submission_akuK": "Submit",
  "CS_one_Basic_information_akKk": "Basic Information",
  "CS_Page_Driver_Mobile_mQCL": "Driver Mobile Number",
  "CS_one_Father_classification_ZASx": "Parent Category Level 1 (en_US)",
  "CS_info_Select_user_WEYA": "Please select User Type and Business Type to get available Contact Reasons",
  "CS_information_Order_Status_ZZvi": "Trip Status",
  "CS_Page_Please_choose_SkUr": "Please select...",
  "CS_one_Import_data_zhsI": "Import Data",
  "CS_one_Applicable_Business_ERQA": "Applicable Business Type",
  "CS_1_Off_aqDQ": "Close",
  "CS_info2__unk_MkzP": "Image Upload",
  "CS_qa_Successfully_saved_GaYt": "Ticket saved successfully",
  "CS_info2_User_Type_ylaU": "User Type",
  "CS_1_Send_asynchronous_rowd": "Send In-app Message and Email",
  "CS_1_Cancel_UVIs": "Cancel",
  "CS_info2_link_Text_Gvnh": "Associated info",
  "CS_Page_Enter_Passenger_vcdv": "Enter Rider ID",
  "CS_one_Cancel_sSYi": "Cancel",
  "CS_one_Add_VToU": "Add",
  "CS_one_Download_Template_XYvP": "Download Template",
  "CS_tickets_Compensation_Deducperiod_HFiB": "Compensation/Deduction Execution Time",
  "CS_info2_Picture_text_mnMQ": "Image description",
  "CS_1_User_Mobile_aNYY": "User Mobile No.",
  "CS_Page_Product_line_gPCE": "Product Line",
  "CS_info_There_is_vxeJ": "There is no content available for this Contact Reason. For more info, please check the (Knowledge Base).",
  "CS_tickets_Today_klqB": "Today",
  "CS_notification_dwyv_UnUJ": "This inbound user is a fleet partner. Only Fleet tools are applicable.",
  "CS_tickets_Search_dVXa": "Search",
  "CS_improvement_Driver_ZOiL": "Driver",
  "CS_one_Scenarios_qeVe": "Scenario",
  "CS_reconstruction_Determination_MvvP": "Confirm",
  "CS_2_Time_of_ynEo": "Refund Time",
  "CS_1_operator_gItF": "Action Performed by",
  "CS_info2_Image_address_QJoY": "Image URL",
  "CS_tickets_Type_of_DvxN": "Ticket Type",
  "CS_tickets_Half_a_SjoS": "Past 6 months",
  "CS_info_Into_the_OLWz": "Inbound user info",
  "CS_page_Unable_to_sJgg": "Unable to resolve ticket",
  "CS_1_Passengers_rXbp": "Rider",
  "CS_page_Unable_to_lQkV": "Unable to close ticket",
  "CS_1_Compensation_Deduction_eyNT": "Compensation/Deduction Details",
  "CS_page_Unable_to_lWwm": "Unable to temporarily save ticket",
  "CS_Page_Passenger_ID_WiFY": "Rider ID",
  "CS_Page_Clear_Query_qLSf": "Clear Search Criteria",
  "CS_info2_View_link_fyZT": "View Link",
  "CS_tickets_Work_order_STXN": "Ticket History",
  "CS_2_Copy_successfully_rlpe": "Copied successfully",
  "CS_one_Grade_classification_sVNq": "Parent Category",
  "CS_Page_Driver_Details_Mnzk": "Driver Details Page",
  "CS_page_Successful_temporary_sFHU": "Ticket temporarily saved",
  "CS_page_Successfully_created_ffvZ": "Ticket created successfully",
  "CS_Page_Purpose_rNGk": "Dropoff Location",
  "CS_Tools_1231_Optimus_AdyenTool_Failure_TWRQ": "Unsuccessful",
  "CS_thpoptimization_Copy_the_CPlW": "Email address copied. This action has been logged. Please remember to follow the company’s information security policies.",
  "CS_1_Status_of_Dkxj": "Status",
  "CS_Adjustment_VsHy_RwJo": "Please enter a reason for skipping",
  "CS_reconstruction_Select_Business_DYpG": "Please select a business type",
  "CS_Settings_Can_not_wuTx": "Cannot be blank",
  "CS_1_Action_Name_sFel": "Action",
  "CS_Page_Driver_Details_uNcn": "Driver Details: Driver ID",
  "CS_pop_Action_zZIq": "Actions",
  "CS_pop_Confirmation_lTpQ": "OK",
  "CS_improvement_Phone_records_Kgdt": "Call History",
  "Help_buchong_Reply_RcHf": "Reply",
  "CS_one_Classification_of_YYEd": "Is this a security-related contact reason (CR)?",
  "CS_info2_Association_ZCdq": "Associate",
  "CS_1_Work_orders_fADf": "Internal message successfully sent for ticket",
  "CS_qa_Collapse_DJRI": "Show Less",
  "CS_improvement_Voice_duration_TNdW": "Call Duration",
  "CS_1_Work_order_pUHt": "Email successfully sent for ticket",
  "CS_1_Mail_address_Hxvv": "Email Address",
  "CS_page_Actual_arrival_YPiM": "Actual Arrival Time",
  "CS_Page_Driver_ID_HNzY": "Driver ID",
  "CS_info_Select_a_CKYG": "Please select a city. If no cities are available, you can select N/A.",
  "Magellan_improvement_When_you_WyDX": "Orders will be cancelled once closed. Please choose carefully.",
  "CS_tickets_Compensation_ID_PjEu": "Compensation ID",
  "CS_5_When_the_WPIZ": "This inbound user is a driver, only driver’s tools are applicable.",
  "CS_one_Please_confirm_BmHM": "Please confirm the selected contact reasons and click \"Confirm\" to validate them.",
  "CS_1_Send_email_oriC": "Send Email",
  "CS_tickets_One_week_YsBK": "Past 1 week",
  "CS_page_Whether_the_pGhP": "Are you sure this ticket has been resolved? Once confirmed, the ticket status will be changed to [Processing].",
  "CS_one_Off_Zqiv": "Close",
  "CS_2_For_security_YqmP": "Recipient's email address is hidden for security reasons. This will not affect your communication.",
  "CS_info_Please_fill_yjjm": "Please enter mobile number",
  "CS_info2_Business_Type_KDsP": "Business Type",
  "CS_1_Send_internal_kufI": "Send Message",
  "CS_1_Save_dSGz": "Save",
  "CS_page_Priority_processor_Gwtc": "Preferred Assignee",
  "CS_1_The_author_xIBI": "From",
  "CS_one_Details_Page_mdDC": "Contact Reason Details Page",
  "CS_page_If_you_RZwt": "Are you sure you want to temporarily save this ticket? This will change the ticket status to [Temporarily Saved].",
  "CS_page_Work_order_vikw": "Ticket resolved successfully",
  "CS_1_Type_kuvZ": "Type",
  "CS_1_Role_QhMU": "Role",
  "CS_one_Please_confirm_ViBj": "Please confirm the selected contact reasons and click \"Confirm\" to discard them.",
  "CS_2_Refund_history_NZXS": "Refund History",
  "CS_info2_Related_Worksheets_TnzD": "Associate Ticket (Optional)",
  "CS_page_This_order_jAmf": "Trip Stops",
  "CS_Page_City_XSgD": "City",
  "CS_qa_Customer_Service_CeXF": "CSR",
  "CS_Page_Passenger_List_ajVZ": "Rider List",
  "CS_1_Latest_before_UTUl": "Sort by Newest",
  "CS_5_Copy_successfully_CcCu": "Copied",
  "CS_1_During_Operation_xWpb": "Action Time",
  "CS_one_Please_select_IHKO": "Please select a country and a business line",
  "CS_one_During_Operation_JDju": "Action Time",
  "CS_qa_More_Paqa": "More",
  "CS_info_Select_Channel_HWlg": "Please select a channel",
  "CS_info2_Rider_Issuing_TDAx": "Time of rider’s trip request",
  "CS_4_Contact_Records_NcjV": "Contact History",
  "ark.global.cs.TOOL_ACTION_associated_ticket": "Associated a ticket",
  "Magellan_improvement_Information_Secure_LRtP": "Information confidentiality reminder",
  "CS_Page_Enter_driver_CirL": "Enter Driver ID",
  "CS_Page_Select_driver_rrhQ": "Please select a driver type",
  "CS_qa_There_is_vPke": "{{inputbox}} contains unsent content. Leaving this page will clear the content. Are you sure you want to leave?",
  "CS_one_Father_classification_lZII": "Parent Category Level 2 (en_US)",
  "CS_info_Mobile_phone_SGyc": "Unable to find user info because mobile number is invalid, or user is not registered.",
  "CS_one_Export_data_YQDj": "Export Data",
  "CS_information_Departure_zaxW": "Departure Point",
  "CS_TicketHandlingPage_This_CR_VWpW": "Manual SOP is already supported for this CR. Please process the ticket according to SOP.",
  "CS_2_Work_Order_anVq": "Ticket Group",
  "CS_info_Select_Business_bhhu": "Please select a business type",
  "CS_Adjustment_ZMnG_gsAL": "Other",
  "CS_information_Order_ID_vVme": "Trip ID",
  "CS_one_User_Type_iRnJ": "User Type",
  "CS_4_Order_details_ulUl": "Trip Details",
  "CS_one_Edit_LtHm": "Edit",
  "CS_info2_If_there_BivS": "Please select an associated ticket (if any)",
  "CS_Page_Billing_models_otMq": "Vehicle Type",
  "CS_Page_Enter_your_kKAs": "Enter mobile number",
  "CS_page_No_email_Uhdl": "You do not have permission to send a reply email",
  "CS_Adjustment_VZmt_VnjZ": "Please select a reason for skipping",
  "CS_Adjustment_oVPm_qPQP": "User is offline or has exited chat",
  "CS_one_View_miAp": "View",
  "CS_fits_OUZR_woGE": "Order Product Line",
  "CS_1_Compensation_deduction_pTJS": "Compensation/Deduction Channel",
  "CS_info2_More_akQx": "View More",
  "CS_1_Work_orders_cLNO": "In-app message successfully sent for ticket",
  "CS_1_Roaming_wzIe": "Roaming",
  "CS_5_Copy_qVgF": "Copy",
  "CS_Page_Star_Standard_ICmt": "Star Rating",
  "CS_page_Estimated_arrival_QwhV": "Estimated Arrival Time",
  "CS_compensation_Refusal_of_hveW": "Compensation Rejected",
  "CS_initialization_Select_Order_dqhz": "Select a Trip",
  "CS_TicketHandlingPage_Artificial_SOP_vwXh": "Manual SOP",
  "CS_Page_Passenger_Email_qveC": "Rider Email",
  "CS_Page_Between_the_eqMJ": "Creation Time",
  "CS_Page_Business_Type_nsHy": "Business Type",
  "CS_page_Do_you_tMFN": "Do you want to close this ticket?",
  "CS_2_Work_Order_fABY": "Ticket ID copied successfully",
  "CS_Page_Pick_up_CNzD": "Pickup Location",
  "More": "More",
  "CS_improvement_Unanswered_qcLt": "No answer",
  "CS_1_Related_Orders_hkRo": "Associate Order",
  "CS_info_Comments_successfully_YcZj": "Comment added",
  "CS_tickets_Enter_the_FCWt": "Inbound User Related Ticket",
  "CS_information_Booking_session_CBQY": "Scheduled Time",
  "ark.global.cs.field.values.ticket_tab_inner_reply": "Internal Message",
  "CS_Page_Driver_ID_TPqW": "Driver ID Number",
  "CS_info_Select_Work_KXNc": "Please select a ticket group",
  "Help_conversations_Robot_chat_QzDc": "Chatbot chat history",
  "CS_tickets_Between_the_mEqx": "Creation Time",
  "CS_2_Passenger_Basic_FFNN": "Basic Rider Info",
  "CS_page_Do_you_GgIB": "Transfer ticket to {{handler}} in {{ticketgroup}}?",
  "CS_1_Enter_text_NYGo": "Enter text...",
  "CS_1_Compensation_ID_BGFF": "Compensation ID",
  "CS_1_Work_order_wyuA": "Ticket Info",
  "CS_info_Select_User_rSZo": "Please select a user type",
  "CS_one_Classification_of_QAlG": "Contact Reason",
  "ark.global.cs.field.values.ticket_tab_asyc_msg": "In-App Message",
  "CS_pop_Can_t_QjXi": "Associated Call Not Found?",
  "Help_version_Telephone_entry_PGun": "Phone Bar",
  "CS_one_You_can_MflO": "Special characters are not allowed, except for “()”, “?”, and spaces",
  "ark.global.cs.field.values.ticket_tab_outer_reply": "External Reply",
  "CS_one_operator_Itcg": "Operator",
  "CS_one_Organization_eUqC": "Organization",
  "CS_5_Comply_with_YDuq": "Please follow the company’s information security policies.",
  "CS_prompt_Driver_registration_mBqS": "Driver registration review task not found",
  "CS_Page_Order_ID_tWzK": "Order ID",
  "CS_one_Classification_of_jyqM": "Contact Reason (en_US)",
  "CS_Page_Status_of_SBuB": "Payment Status",
  "CS_Page_Enter_ID_IgwX": "Enter ID number",
  "TEXT_ERRMSG_OK": "Success",
  "Help_want__Change_pUeS": "More suggestions",
  "Help_version_Thread_tmgY": "Contact Reason",
  "CS_Page_Passenger_Mobile_ckjq": "Rider Mobile Number",
  "CS_qa_User_Tjti": "User",
  "CS_one_Classification_of_AlnN": "Contact Reason (en_US)",
  "CS_1_Help_us_ilXL": "Help Us Improve",
  "CS_one_Are_you_eqhN": "Are you sure you want to create a new contact reason? Once created, the new CR will take effect in the applicable country. Please inform the relevant colleagues in the corresponding country.",
  "CS_initialization_Select_City_uKvx": "Select a City",
  "CS_pop_Bind_fsRd": "Added",
  "CS_2_Classification_of_QmXS": "Contact Reason",
  "kfcommon-fe-i18n-knowledge---knowledgeConfig.robot": "Robots",
  "ark.global.cs.field.title.ticket_tab_log": "Ticket Log",
  "CS_pop_Yes_yDMc": "Yes",
  "CS_tickets_One_year_gmPi": "Past 1 year",
  "CS_page_Internal_reply_pruf": "Internal reply cannot be blank",
  "ark.global.cs.field.title.ticket_tab_info": "Info Record",
  "CS_Page_Front_ID_apqL": "Fleet Details: Fleet ID",
  "CS_1_User_Name_dhWx": "User Name",
  "CS_one_Batch_scrap_qzlO": "Batch Discard",
  "CS_info2__unk_RIxc": "Insert",
  "CS_Tools_colombo_tool_platform_Cancel_gNzm": "Cancel",
  "CS_one_Parental_classification_zEhp": "Parent Category (en_US)",
  "Help_buchong_Reply_Record_dsUU": "Reply History",
  "CS_info2_All_orders_yVmI": "Showing all orders for this user in the past 180 days",
  "CS_1_The_oldest_vXHS": "Sort by Oldest",
  "CS_monitor_Each_compensation_BfxO": "All compensation requests are logged. Please ensure requests meet the Customer Service Compensation Policy. Requests that do not meet the policy guidelines will be reviewed internally.",
  "comTool.channelRefundERR": "This order has no bill. Thus, original channel refund is not applicable.",
  "review.auditInfo": "Details",
  "list.orderId": "Order ID",
  "comTool.refundStatus": "refund status",
  "common.pleaseSelect": "select",
  "new.tags": "tags",
  "comfort.vehicleModel": "Vehicle Model",
  "comfort.requiredYear": "Year >",
  "chat.save": "Save",
  "review.submitReview": "Submit for Review",
  "new.continueHandle": "continue to deal with",
  "comTool.driverV": "Unable to compensate because the user type is PASSENGER",
  "comTool.balance": "balance",
  "automation.action": "action",
  "list.compensatePhone": "User Phone",
  "staticConfig.false": "no",
  "work.businessTypeName": "Business Type",
  "new.orderInfo": "Order Information",
  "review.viewFlowchart": "View Flowchart",
  "comTool.riderCompensation": "Rider Compensation",
  "comTool.driverActualRevenue": "Driver Actual Revenue",
  "comTool.driverId": "Driver ID",
  "new.knowdgeBase": "Knowledge base",
  "comTool.passenger": "Passenger",
  "list.channel": "channel",
  "clipper.clipperTitle": "Associated Clipper Safety Ticket Information",
  "comTool.reasonForCompensation": "Reason for Compensation",
  "comTool.driverPhone": "Driver's Phone Number",
  "review.commitTime": "Time Submitted",
  "common.system": "system",
  "common.more": "more",
  "comTool.amountERR": "Amount Input Error",
  "staticConfig.yes": "yes",
  "staticConfig.operationSuccessfully": "Operation succeeded",
  "list.worksheetId": "Ticket Id",
  "comTool.status": "payment status",
  "comTool.driverDeduction": "Driver Deduction",
  "new.ticketRefreshV": "This ticket has been updated，continue or not？",
  "common.jingmoThreeMonths": "Only Display Silence Log of Latest Three Months",
  "comTool.refundCost": "refunded amount",
  "list.amount": "Amount",
  "review.auditor": "Reviewed by",
  "common.Toolbox": "Toolbox",
  "common.ticketList": "Ticket List",
  "comfort.city": "City",
  "review.taskName": "Task Type",
  "staticConfig.channelSetting": "channel settings",
  "comTool.detailsOfCompensation": "Details of Compensation",
  "clipper.clipperDetail": "This ticket has a related Clipper safety ticket",
  "comTool.driverCompensation": "Driver Compensation",
  "review.submitReviewConfirm": "Are you sure you want to submit this information for review?",
  "new.uploadFailed": "upload fail. Please try again",
  "comTool.operationStatus": "result",
  "clipper.status": "Clipper Ticket Status",
  "review.actions": "Actions",
  "comTool.passengerCouponV": "Voucher cannot be requested, for the user type is DRIVER",
  "work.Workbench": "My Workbench",
  "comTool.cost": "payment amount",
  "chat.transfer": "Transfer",
  "chat.onlineResponse": "In-App message",
  "review.auditTime": "Reviewed on",
  "staticConfig.no": "no",
  "staticConfig.businessTypeName": "The name of Business Type",
  "new.NullEmergencyContact": "User has not set emergency contact",
  "new.emergencyContact": "Trusted Contacts",
  "common.confirm": "Confirm",
  "comfort.model": "Vehicle Model",
  "clipper.T3first": "Ticket claimed time by T3",
  "common.abnormalReminder": "Risk Alert",
  "new.editTime": "edit time",
  "comTool.pay": "Rider 99Pay wallet",
  "review.undoChanges": "Undo Changes",
  "comTool.channelName": "channel name",
  "callInfo.operation": "Operation",
  "clipper.creationDate": "Clipper Ticket Created Time",
  "common.continueTocompensate": "Compensate Anyway",
  "comTool.coupon": "Voucher",
  "list.amountRange": "Amount Range  ",
  "comTool.channelRefund": "original channel refund",
  "clipper.ticketID": "Clipper Ticket ID",
  "comfort.search": "Search",
  "clipper.T2first": "Ticket claimed time by T2",
  "new.PleaseCreateTicket": "Please create the ticket first",
  "comTool.refund": "refund",
  "detail.handle": "deal with",
  "new.fileBig": "file is too big. Please select the file less than 5M",
  "create.NewTicket": "New Ticket",
  "staticConfig.true": "yes",
  "review.auditResult": "Result",
  "new.editUser": "editor",
  "review.modify": "Edit",
  "detail.handleV": "This ticket is under processing. Are you sure to claim it?",
  "new.refreshTicket": "refresh this page",
  "comTool.routeOfCompensation": "Route of Compensation",
  "common.recommendationNotcompensate": "Recommendation: Do not compensate.",
  "common.to": "change to",
  "comTool.noOrderAll": "This ticket has no order. Thus, compensation is not applicable.",
  "clipper.clickToView": "Click to view",
  "common.up": "Fold"
}